import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { examsApi } from 'App';
import { PaginationAPI, parseDate } from '@shared';
import { parse } from 'date-fns';

export type ExamUI = {
  uuid: string;
  name: string;
  completedExamCount: number;
  isRecordOnly: boolean;
  expired: boolean;
};

type ExamsUI = {
  pagination: PaginationAPI;
  exams: ExamUI[];
};

type Args = { partner: string; course: string; page: number };

export function useExams({ partner, course, page }: Args): UseQueryResult<ExamsUI> {
  const offset = page - 1;
  const queryClient = useQueryClient();

  const isExpired = (examEndTimeEt: Date) => {
    const nowAtEt = parse(
      new Date().toLocaleString('en-GB', { timeZone: 'EST' }),
      'dd/MM/yyyy, HH:mm:ss',
      new Date()
    );
    return examEndTimeEt < nowAtEt;
  };

  return useQuery(['all exams', course, page], () => examsApi.getPack(partner, course, offset), {
    select: ({ pagination, data }) => ({
      pagination,
      exams: data.map((exam) => ({
        uuid: exam.exam.uuid,
        name: exam.exam.label,
        completedExamCount: exam.completedExamCount,
        isRecordOnly: exam.exam.recordOnly,
        expired: isExpired(parseDate(exam.exam.endTime)),
      })),
    }),
    onSuccess: (data) =>
      data.exams.map((exam) => queryClient.setQueryData(['exam', exam.uuid], exam)),
    cacheTime: 0,
  });
}
